module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-373.dd71dad.woff2";